module.exports = __webpack_public_path__ + "static/img/bgmap2.5a4c041a.png";